export default function combine(...methods) {
  return (...args) => {
    methods.forEach((method) => {
      method.apply(this, args)
    })
  }
}
